<template>
    <div class="mainbusinessModuleWarp">
        <div  class="moduleTitle">人力资源外包服务</div>
        <div>
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm" label-position='top' :validate-on-rule-change="false">
                <div class="dialogformCenter">
                    <div class="bigTitle">一、从业人员</div>
                    <el-form-item label=" 1.从业人员总数：" prop="1">
                        <el-input v-model="ruleForm[1]" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label=" 2.本科及以上学历比例（%）：" prop="2">
                        <el-input v-model="ruleForm[2]" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label="3.了解相关法律法规，有专职或兼职律师" prop="3">
                        <el-radio-group v-model="ruleForm[3]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="4.具有人力资源、财务会计、经济管理等专业人才：" prop="4">
                        <el-radio-group v-model="ruleForm[4]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <div class="bigTitle">二、服务场所建筑面积</div>
                    <el-form-item label="5.服务场所建筑面积（平米）：" prop="5">
                        <el-input v-model="ruleForm[5]" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label="6.设有服务接待窗口：" prop="6">
                        <el-radio-group v-model="ruleForm[6]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="7.设有服务接待室：" prop="7">
                        <el-radio-group v-model="ruleForm[7]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label=" 8.设有服务接待厅：" prop="8">
                        <el-radio-group v-model="ruleForm[8]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="9.服务接待厅面积不少于50平米：" prop="9">
                        <el-radio-group v-model="ruleForm[9]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <div class="bigTitle">三、服务规模</div>
                    <el-form-item label="10.年服务客户数：" prop="10">
                        <el-input v-model="ruleForm[10]" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label="11.年服务人次：" prop="11">
                        <el-input v-model="ruleForm[11]" placeholder="请输入"></el-input>
                    </el-form-item>
                    <div class="bigTitle">四、服务内容</div>
                    <el-form-item label="12.开展几类人力资源外包服务：" prop="12">
                        <el-input v-model="ruleForm[12]" placeholder="请输入"></el-input>
                    </el-form-item>
                    <div class="bigTitle">五、服务质量要求</div>
                    <el-form-item label="13.月度员工人事服务手续完成率（%）：" prop="13">
                        <el-input v-model="ruleForm[13]" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label="14.员工缴纳社会保险完成率100%：" prop="14">
                        <!-- <el-input v-model="ruleForm[14]" placeholder="请输入"></el-input> -->
                        <el-radio-group v-model="ruleForm[14]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="15.各项外包服务时点控制符合要求：" prop="15">
                        <el-radio-group v-model="ruleForm[15]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="16.对服务的过程和结果做出完整、准确记录：" prop="16">
                        <el-radio-group v-model="ruleForm[16]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="17.建立服务质量控制体系：" prop="17">
                        <el-radio-group v-model="ruleForm[17]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="18.具有完善的服务质量控制体系，并获得相关认证：" prop="18">
                        <el-radio-group v-model="ruleForm[18]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <div class="bigTitle">六、信息化管理程度</div>
                    <el-form-item label="19.通过电子表格、文档进行记录和管理客户、员工基本信息和业务服务信息：" prop="19">
                        <el-radio-group v-model="ruleForm[19]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="20.初步建立信息化管理系统，有完整的信息记录和基本的安全保密措施：" prop="20">
                        <el-radio-group v-model="ruleForm[20]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="21.员工基本信息实现系统化、标准化管理：" prop="21">
                        <el-radio-group v-model="ruleForm[21]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="22.员工业务信息通过电子表格管理：" prop="22">
                        <el-radio-group v-model="ruleForm[22]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="23.建立较完善的业务信息化管理系统，对客户、员工信息可以比较全面的实施管理，制定了比较全面的信息安全制度和措施：" prop="23">
                        <el-radio-group v-model="ruleForm[23]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="24.部分业务信息实现信息系统管理：" prop="24">
                        <el-radio-group v-model="ruleForm[24]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="25.建立完善的信息化管理系统，对客户、员工的基本信息、业务的实施过程和成果都有完善的记录，制定了全面的信息安全制度和措施：" prop="25">
                        <el-radio-group v-model="ruleForm[25]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="26.主要业务工作流程实现信息系统管理：" prop="26">
                        <el-radio-group v-model="ruleForm[26]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label=" 27.所有的业务工作流程实现信息系统管理：" prop="27">
                        <el-radio-group v-model="ruleForm[27]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <div class="bigTitle">七、材料归档</div>
                    <el-form-item label="  28.材料归档率达（%）：" prop="28">
                        <el-input v-model="ruleForm[28]" placeholder="请输入"></el-input>
                    </el-form-item>
                    <div class="bigTitle">八、客户投诉记录及处理</div>
                    <el-form-item label="29.是否设有投诉电话：" prop="29">
                        <el-radio-group v-model="ruleForm[29]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="30.接到投诉到介入处理再到反馈当事人处理结果所需时间（天）：" prop="30">
                        <el-input v-model="ruleForm[30]" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label="  31.是否有投诉及处理情况记录" prop="31">
                        <el-radio-group v-model="ruleForm[31]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="32.投诉及处理情况记录保存年限（年）：" prop="32">
                        <el-input v-model="ruleForm[32]" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label=" 33.设有5部以上24小时客户服务和投诉电话，或设有客户服务小型呼叫中心：" prop="33">
                        <el-radio-group v-model="ruleForm[33]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>

                </div>
                <div class="dialogformBottomBtnBox" v-if="!result">
                    <el-button type="primary" @click="saveForm" class="submitBtn">保存</el-button>
                    <el-button type="primary" @click="submitForm('ruleForm')" class="submitBtn">提交</el-button>
                    <el-button @click="cancelForm" class="cancelBtn">关闭</el-button>
                </div>
                <div class="dialogformBottomBtnBox" v-else>
                    <el-button @click="cancelForm" class="cancelBtn">关闭</el-button>
                </div>
            </el-form>

        </div>
    </div>
</template>
<script>
import { httpService } from "@/service/httpService";
export default {
    props: ['saveId', 'result'],
    data() {
        return {
            ruleForm: {
                1: '',
                2: '',
                3: '',
                4: '',
                5: '',
                6: '',
                7: '',
                8: '',
                9: '',
                10: '',
                11: '',
                12: '',
                13: '',
                14: '',
                15: '',
                16: '',
                17: '',
                18: '',
                19: '',
                20: '',
                21: '',
                22: '',
                23: '',
                24: '',
                25: '',
                26: '',
                27: '',
                28: '',
                29: '',
                30: '',
                31: '',
                32: '',
                33: '',
            },
            rules: {
                // 正整数
                1: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: '^[0-9]*[1-9][0-9]*$', message: '请输入大于0的正整数', trigger: 'blur' },
                ],
                2: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: /^(?:0|[1-9][0-9]?|100)$/, message: '只能输入0-100,例 1 代表 1%', trigger: 'blur' },
                ],

                3: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                4: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                // 小数
                5: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: '^(0|[1-9][0-9]*)$', message: '请输入大于等于0的正整数', trigger: 'blur' },
                ],
                6: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                7: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                8: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                // 多选
                9: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                10: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: '^(0|[1-9][0-9]*)$', message: '请输入大于等于0的正整数', trigger: 'blur' },
                ],
                11: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: '^(0|[1-9][0-9]*)$', message: '请输入大于等于0的正整数', trigger: 'blur' },
                ],
                12: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: '^(0|[1-9][0-9]*)$', message: '请输入大于等于0的正整数', trigger: 'blur' },
                ],
                13: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: /^(?:0|[1-9][0-9]?|100)$/, message: '只能输入0-100,例 1 代表 1%', trigger: 'blur' },
                ],
                14: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                15: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                16: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                17: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                18: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                19: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                20: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                21: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                22: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                23: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                24: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                25: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                26: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                27: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                28: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: /^(?:0|[1-9][0-9]?|100)$/, message: '只能输入0-100,例 1 代表 1%', trigger: 'blur' },
                ],
                29: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],

                30: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: '^[0-9]*[1-9][0-9]*$', message: '请输入大于0的正整数', trigger: 'blur' },
                ],
                31: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                32: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: '^(0|[1-9][0-9]*)$', message: '请输入大于等于0的正整数', trigger: 'blur' },
                ],
                33: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],

            },
        }
    },
    created() {
        this.yetData()
    },
    methods: {
        saveForm() {
            let NewDataList = []
            for (const key in this.ruleForm) {
                let obj = {}
                obj.serialNumber = key;
                obj.evaluateValue = this.ruleForm[key]
                NewDataList.push(obj)
            }
            httpService.saveB(this.saveId, NewDataList).then(res => {
                if (res.code == 200) {
                    this.$message({
                        message: '保存成功',
                        type: 'success'
                    });
                    this.$emit('getyetServiceFn')
                }
            })
        },
        // 提交
        submitForm(formName) {
            // 保存不通过validate检验
            this.$refs[formName].validate((valid, obj) => {
                if (valid) {
                    let NewDataList = []
                    for (const key in this.ruleForm) {
                        let obj = {}
                        obj.serialNumber = key;
                        obj.evaluateValue = this.ruleForm[key]
                        NewDataList.push(obj)
                    }
                    httpService.addScore(this.saveId,NewDataList).then(res => {
                        if (res.code == 200) {
                            this.$message({
                                message: '提交成功',
                                type: 'success'
                            });
                            this.$emit('getyetServiceFn')
                        }
                    })
                } else {
                    let arr = []
                    for (const key in obj) {
                        if (Object.hasOwnProperty.call(obj, key)) {
                            let ele = key + '题、'
                            arr.push(ele)
                        }
                    }
                    let str = arr.join('')
                    this.$message.error(`${str}未填写，请检查！`);
                    return false;
                }
            });
        },

        cancelForm() {
            this.$emit('getyetServiceFn')
        },
        // 回填表单数据
        yetData() {
              httpService.getCorpIndicatorOption(this.saveId).then(res => {
                if (res.code == 200) {
                    if (res.result.length != 0) {
                        let obj = {}
                        for (const key in res.result) {
                            obj[res.result[key].serialNumber] = res.result[key].evaluateValue
                        }
                        this.ruleForm = obj
                    }
                }
            })
        },
    }


}
</script>
<style lang="less" scoped>
.mainbusinessModal9Warp {
}
</style>


